exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-page-tsx": () => import("./../../../src/templates/page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */),
  "slice---src-components-footer-index-tsx": () => import("./../../../src/components/Footer/index.tsx" /* webpackChunkName: "slice---src-components-footer-index-tsx" */),
  "slice---src-components-header-index-tsx": () => import("./../../../src/components/Header/index.tsx" /* webpackChunkName: "slice---src-components-header-index-tsx" */)
}

